import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

import CountUp from "react-countup";
function VideoLandingPage({location}) {
  const [openVideo, setOpenVideo] = useState(null);

  const videos = [
   

    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770369651/glazma3_p66fj2.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770369652/glazma_4_znh1ee.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770369657/glazma_5_s8g1w4.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770369647/glazma2_lcb2tm.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770369643/glazma1_zqkulz.mp4",

  
  ];

  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.01] } 
    );

    videoRefs.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      videoRefs.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, []);

  return (
    <>
      <div className="test-home-video-bg">
        <div className="test-home-video-main">
        

  

{/* _________________________________________________________________Heading Text  ______________________________________________________________________________________ */}
    
    
    
          <div className="test-home-video-cont"  >
            {videos.map((src, i) => (
              <div
                className="test-home-video-box"
                key={i}
                onClick={() => setOpenVideo(src)}
              >
                <video
                  src={src}
                  ref={(el) => (videoRefs.current[i] = el)}
                  className="video-player"
                  muted
                  loop
                  playsInline
                />
              </div>
            ))}
          </div>




{/* For Phone Only ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::; */}


        </div>
      </div>

      {openVideo && (
        <div className="popup-overlay">
          <div className="popup-close" onClick={() => setOpenVideo(null)}>
            ✕
          </div>
          <div className="popup-video-container">
            <video
              src={openVideo}
              controls
              autoPlay
              muted
              loop
              className="popup-video"
              playsInline
            />
          </div>
        </div>
      )}
    </>
  );
}

export default VideoLandingPage;

